<template>
  <div class="panel" :key="`panel-${$store.state.business.businessId}`">
    <SideBar :items="$router.options.routes[1].children" />
    <HeaderBar />
    <div class="panel__main">
      <router-view name="panel" />
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/SideBar";
import HeaderBar from "@/components/HeaderBar";

import { mapActions } from "vuex";

export default {
  components: {
    SideBar,
    HeaderBar
  },
  name: "Panel",
  created() {
    this.getUserByID();
  },
  data: () => ({
    mobile: window.innerWidth < 900
  }),
  methods: {
    ...mapActions({
      getUserByID: "getUserByID"
    })
  }
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img+$img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

.panel {
  height: 100%;
  &__main {
    // position: absolute;
    // margin-top: 4rem;
    margin-left: 0;
    width: 100%;
    height: calc(100% - 4rem);
    // background-color: #eceff8;
    @include mq($md) {
      margin-left: 18rem;
      width: calc(100% - 18rem);
    }
  }
}
</style>
